export const REQUEST_OBJECTIVE = "request_objective_for_select"
export const OBJECTIVE_SUCCESS = "objective_for_select_success"
export const OBJECTIVE_FAILURE = "objective_for_select_failure"
export const OBJECTIVE_ACTION_CHANGES = "objective_for_select_action_changes"

export const CLEAR_OBJECTIVE_STATE = "clear_objective_for_select_state"